import {RouterModule, Routes} from '@angular/router';
import {AplicacionVersionFormComponent} from './form/aplicacion-version-form.component';
import {AplicacionVersionListComponent} from './list/aplicacion-version-list.component';
import {NgModule} from '@angular/core';

const routes: Routes = [
  {
    path: '',
    component: AplicacionVersionListComponent,
    pathMatch: 'full'
  },
  {
    path: 'registrar',
    component: AplicacionVersionFormComponent,
  },
  {
    path: 'modificar',
    component: AplicacionVersionFormComponent,
  },
  {
    path: 'ver',
    component: AplicacionVersionFormComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class AplicacionVersionRoutingModule {
}
